import { createSelector, Selector } from '@reduxjs/toolkit'
import { EntityType } from 'api'
import { compact } from 'lodash'
import { createEntitySelector } from '../entitySelectors'
import {
  createTradingEntityCanTradeCollateralBasketsSelector,
  createTradingEntityCanTradeCollaterals,
  isTradingEntityAssignedToAuthorisedUserSelector,
  isTradingEntityInAuthorisedUserOrganisationSelector,
  isTradingEntityTradable
} from './tradingEntityFilterSelectors'

export const createTradingEntityFiltersForInstrumentSelector = <P>(instrumentIdSelector: Selector<{}, null | undefined | string, [P]>) =>
  createSelector(
    [
      createEntitySelector(instrumentIdSelector, EntityType.COLLATERAL),
      createEntitySelector(instrumentIdSelector, EntityType.COLLATERAL_BASKET),
      isTradingEntityInAuthorisedUserOrganisationSelector,
      isTradingEntityAssignedToAuthorisedUserSelector,
      createTradingEntityCanTradeCollateralBasketsSelector
    ],
    (
      collateral,
      collateralBasket,
      isTradingEntityInAuthorisedUserOrganisation,
      isTradingEntityAssignedToAuthorisedUserSelector,
      createTradingEntityCanTradeCollateralBaskets
    ) => {
      return compact([
        isTradingEntityInAuthorisedUserOrganisation,
        isTradingEntityAssignedToAuthorisedUserSelector,
        isTradingEntityTradable,
        collateral && createTradingEntityCanTradeCollaterals([{ collateral, marketType: null }]),
        collateralBasket && createTradingEntityCanTradeCollateralBaskets([{ collateralBasket, marketType: null }])
      ])
    }
  )
